import { getRequest, putRequest } from "../apiConfig";

const BASE = "/admin/blacklist";

// ✅ GET pending requests
export const getRequests = () => getRequest(`${BASE}/requests`);

// ✅ Approve / Reject request
export const approveRequest = (requestId) =>
  putRequest(`${BASE}/requests/${requestId}/approve`, {});

export const rejectRequest = (requestId) =>
  putRequest(`${BASE}/requests/${requestId}/reject`, {});

// ✅ GET blacklisted businesses + employees
export const getBlacklisted = () => getRequest(`${BASE}/blacklisted`);

// ✅ Unblacklist
export const unblacklistBusiness = (businessId) =>
  putRequest(`${BASE}/businesses/${businessId}/unblacklist`, {});

export const unblacklistEmployee = (employeeId) =>
  putRequest(`${BASE}/employees/${employeeId}/unblacklist`, {});
